import { WorkflowTaskSummaryModel } from './workflowTaskSummary.model';
import { WithSummaryModel } from '../../../../../common/entity/dto/plain/withSummary.model';
import { DiscussionSummaryModel } from '../../../../../discussion/modules/common/api/model/discussionSummary.model';
import { WorkflowTaskChildSummaryModel } from '../child/workflowTaskChildSummary.model';

export class WorkflowTaskModel implements WithSummaryModel<WorkflowTaskSummaryModel> {
    summary: WorkflowTaskSummaryModel;
    errorStackTrace: string;
    discussion: DiscussionSummaryModel;
    children: WorkflowTaskChildSummaryModel[] = [];
    payload: string;
}
